import { render, staticRenderFns } from "./DocumentPositions.vue?vue&type=template&id=19fa1342&"
import script from "./DocumentPositions.vue?vue&type=script&lang=js&"
export * from "./DocumentPositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports